module.exports = __webpack_public_path__ + "static/Slide5-b1d51a58c344fb2656f97de04ea3dc9e.jpg";